import React, { useContext, useState } from 'react';
import Axios from 'axios';
import style from './App.module.scss'
import logo from '../../assets/img/Logo.svg'
import { AuthContext } from '../../context/Auth';
import { defineToken, takeToken, DefineRotinas, validateToken, takeRotinas, takeNameUser } from '../../utils/validateToken';
import { useErrorSuccess } from '../../hooks/useErrorSuccess';

type Login = {
  login: string | undefined,
  senha: string | undefined,
}

function App() {

  const {
    setAuth,
    setToken,
    setLogin,
    setIdUsuario,
    setUsuarioRotinas } = useContext<any>(AuthContext);

    const { setErrorSuccess } = useErrorSuccess();

  const [login, ChangeLogin] = useState<Login>({ login: '', senha: '' });

  const [isVisiblePassword, setIsVisiblePassword] = useState<boolean>(false);

  const alterVisible = () => setIsVisiblePassword(!isVisiblePassword)

  if (validateToken()) {
    setLogin(takeNameUser() ?? '');
    setUsuarioRotinas(takeRotinas() ?? []);
    setToken(takeToken());
    setAuth(true);
  }

  async function Autorization(data: any): Promise<void> {
    defineToken(data);
    setLogin(data.nome);
    setToken(data.token);
    setIdUsuario(data.id);
  }

  async function HandleSubmit(e: React.MouseEvent) {

    e.preventDefault();

    await Axios.post(`${process.env.REACT_APP_PUBLIC_URL}/usuario/auth`, login, { headers: { 'Authorization': null } })
      .then(e => {
        if (e.data.nome != "cadastro") {
          Autorization(e.data);
          return e.data;
        }
        setErrorSuccess({mensagem:'Usuário não autorizado', status: 'error'})
      })
      .then(dado => (
        Axios.get(
          `${process.env.REACT_APP_PUBLIC_URL}/permissao/validar/${dado.id}`,
          {
            headers: { 'Authorization': 'Bearer ' + dado.token }
          }
        )
          .then(
            data => {
              setErrorSuccess({
                mensagem: 'Sendo Redirecionado!',
                status: 'success'
              })
              setUsuarioRotinas(data?.data || []);
              DefineRotinas(data?.data || []);
              setAuth(true);
            }
          )
          .catch(
            err => setErrorSuccess(
             { mensagem: err.response?.data?.mensagem || 'Não encontramos o usuário', status: 'error'}
            )
          )
      ))
      .catch(e =>  setErrorSuccess(
             { mensagem: e.response?.data?.mensagem || 'Não encontramos o usuário', status: 'error'}
            ))
  };

  return (
    <>
      <section className={style.conteiner}>
        <section className={style.topo} />
        <section className={style.corpo}>
          <section className={style.login}>
            <img src={logo} aria-label='Comunidade das Nações' />
            <form className={style.formulario}>
              <input className={style.input}
                type='email'
                placeholder='Usuario'
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  ChangeLogin(
                    (prevState: Login) => (
                      {
                        ...prevState,
                        login: e.target.value,
                      }
                    )
                  )
                }>

              </input>
              <div style={{ position: 'relative', width: '100%', display: 'flex' }}>
              <input className={style.input}
                style={{ width: '100%' }}
                type={isVisiblePassword ? 'text' : 'password'}
                placeholder={'Senha'}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  ChangeLogin(
                    (prevState: Login) => (
                      {
                        ...prevState,
                        senha: e.target.value
                      }
                    )
                  )
                }
              />
              <div
              id='active-visible'
              style={{
                position: 'absolute',
                right: 0,
                top: 1,
                 width: '40px',
                 height: '78%',
                  background: '#105675',
                  borderRadius: '0 4px 4px 0',
                  border: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
               }} onClick={alterVisible}>
<svg xmlns="http://www.w3.org/2000/svg" style={{ height: '50%' }} fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" className="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>

               </div>
              </div>
              <button type='submit' className={style.botao}
                onClick={HandleSubmit}
              >Acessar</button>
            </form>
            <a className={style.botaoSenha}>Recuperar sua senha.</a>

          </section>
        </section>
      </section>
    </>
  );
}

export default App;
